export default ".container-adresse-historique {\n  float: right;\n}\n\n.current_footer {\n  color: var(--text-dialog) !important;\n  font-size: 0.9em;\n}"